<template>
    <div
      v-if="visible"
      @click.stop="handleClick"
      :style="{
        'right': styleRight,
        'bottom': styleBottom
      }"
      style="z-index: 99;"
      class="el-backtop">
      <slot>
        <el-icon name="caret-top" class="font20"></el-icon>
      </slot>
    </div>
</template>
<script>
  import throttle from 'throttle-debounce/throttle';
  export default {
    name: 'ElBacktop',
    props: {
      visibilityHeight: {
        type: Number,
        default: 200
      },
      target: [String],
      right: {
        type: Number,
        default: 40
      },
      bottom: {
        type: Number,
        default: 40
      }
    },
    data() {
      return {
        el: null,
        container: null,
        visible: false
      };
    },
    computed: {
      styleBottom() {
        return `${this.bottom}px`;
      },
      styleRight() {
        return `${this.right}px`;
      }

    },
    mounted() {
      window.addEventListener('scroll',()=>{
        this.onScroll()
      })
    },
    methods: {
      onScroll() {
        const scrollTop = document.documentElement.scrollTop;;
        this.visible = scrollTop >= this.visibilityHeight;
      },
      handleClick(){
        document.getElementById('html').scrollIntoView()
      }
    }

  };

</script>
<style scoped>
  @media only screen and (max-width: 767px) {
    .el-backtop{
      right: 0.4rem!important;
      bottom: 0.4rem!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/backtop.vue